import * as helper from '../helper';

export function initMobileMenu() {
	const headerMenuButton: HTMLAnchorElement = helper.$('.header-menubtn')[0];
	const mobileNavigation: HTMLDivElement = helper.$('.navmobile')[0];

	helper.addClickListener(headerMenuButton, (e:MouseEvent) => {
		e.preventDefault();
		helper.toggleClass(headerMenuButton, 'open');
		helper.toggleClass(mobileNavigation, 'outside');
	})
}
